var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform, Type } from 'class-transformer';
import { humanReadableRoles } from '../user/user';
import { AccountModel } from '../account/account';
export class AuthenticationGroupModel {
    group = '';
    userRole = null;
    id;
    getHumanReadableRole() {
        return humanReadableRoles[this.userRole ?? ''];
    }
}
__decorate([
    Expose({ toClassOnly: true }),
    Transform((_, column) => column.group, { toClassOnly: true }),
    __metadata("design:type", String)
], AuthenticationGroupModel.prototype, "id", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthenticationGroupModel.prototype, "getHumanReadableRole", null);
export class AuthGroupModel {
    groupName = '';
    userRole = null;
    accounts = [];
    id;
    getHumanReadableRole() {
        return humanReadableRoles[this.userRole ?? ''];
    }
}
__decorate([
    Type(() => AccountModel),
    __metadata("design:type", Array)
], AuthGroupModel.prototype, "accounts", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Transform((_, column) => column.groupName, { toClassOnly: true }),
    __metadata("design:type", String)
], AuthGroupModel.prototype, "id", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthGroupModel.prototype, "getHumanReadableRole", null);
export class AuthGroupUpdateRequestModel extends AuthGroupModel {
    originalGroupName;
}
export class AuthGroupValidationRequestModel {
    groupName;
}
export class AuthGroupBulkDeleteRequestModel {
    accountType;
    groupName;
}
export class AuthGroupValidationResponseModel {
    valid;
    reason;
}
//# sourceMappingURL=authentication-group.js.map